import { lazy } from 'react';

const AddGuardianContactModal = lazy(() =>
  import('./components/AddGuardianContactModal'),
);

const PersonalizedPlanDeadlinesModal = lazy(() =>
  import('./components/PersonalizedPlanDeadlinesModal'),
);

export default {
  ADD_GUARDIAN_CONTACT_MODAL: AddGuardianContactModal,
  PERSONALIZED_PLAN_DEADLINES: PersonalizedPlanDeadlinesModal,
};
